export default __webpack_public_path__ + "e02190a6bf0f557ea1cd24097abced1c.png";